import { defineSlotRecipe } from '@chakra-ui/react';
export const actionBarRecipe = defineSlotRecipe({
    className: 'chakra-action-bar',
    slots: [
        'positioner',
        'content',
        'separator',
        'selectionTrigger',
        'closeTrigger',
    ],
    base: {
        positioner: {
            position: 'fixed',
            display: 'flex',
            pointerEvents: 'none',
            insetInline: 0,
            '--action-bar-offset': 'spacing.4',
        },
        content: {
            minW: { base: 'calc(100vw - 2rem)', md: 'auto' },
            maxW: {
                base: 'calc(100vw - 2rem)',
                md: 'min(720px, calc(100vw - 2rem))',
            },
            display: 'flex',
            alignItems: 'center',
            gap: 2.5,
            px: { base: 3, md: 3.5 },
            py: 2.5,
            overflow: 'hidden',
            position: 'relative',
            pointerEvents: 'auto',
            rounded: '2xl',
            color: 'white',
            bg: 'rgba(26, 26, 26, 0.9)',
            background: 'linear-gradient(135deg, var(--action-bar-glow), transparent 42%), linear-gradient(180deg, rgba(255,255,255,0.10), rgba(255,255,255,0.026)), rgba(26, 26, 26, 0.9)',
            border: '1px solid',
            borderColor: 'whiteAlpha.200',
            boxShadow: '0 0 0 1px var(--action-bar-glow)',
            backdropFilter: 'blur(24px) saturate(170%)',
            translate: 'calc(-1 * var(--scrollbar-width) / 2) 0px',
            '--action-bar-accent': '#b9a7ff',
            '--action-bar-glow': 'rgba(185, 167, 255, 0.12)',
            _open: {
                animationName: 'slide-from-bottom, fade-in',
                animationDuration: 'moderate',
            },
            _closed: {
                animationName: 'slide-to-bottom, fade-out',
                animationDuration: 'faster',
            },
            _before: {
                content: '""',
                position: 'absolute',
                inset: 0,
                pointerEvents: 'none',
                background: 'linear-gradient(90deg, rgba(255,255,255,0.12), transparent 30%), radial-gradient(circle at 16% 0%, var(--action-bar-glow), transparent 34%)',
                opacity: 0.86,
            },
            '& > *': {
                position: 'relative',
                zIndex: 1,
            },
            '& [data-action-bar-primary]': {
                h: 8,
                px: 3,
                rounded: 'xl',
                color: 'gray.950',
                bg: 'rgba(255, 255, 255, 0.94)',
                border: '1px solid',
                borderColor: 'whiteAlpha.500',
                fontWeight: 'medium',
                _hover: {
                    bg: 'white',
                    transform: 'translateY(-1px)',
                },
                _active: {
                    bg: 'whiteAlpha.900',
                    transform: 'translateY(0)',
                },
            },
            '& [data-action-bar-close]': {
                h: 8,
                px: 2.5,
                rounded: 'xl',
                color: 'whiteAlpha.700',
                fontWeight: 'normal',
                _hover: {
                    bg: 'whiteAlpha.100',
                    color: 'white',
                },
            },
        },
        separator: {
            width: '1px',
            height: 5,
            bg: 'whiteAlpha.200',
        },
        selectionTrigger: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 2,
            alignSelf: 'stretch',
            textStyle: 'sm',
            px: 4,
            py: 1,
            rounded: 'xl',
            color: 'white',
            bg: 'whiteAlpha.100',
            border: '1px dashed',
            borderColor: 'whiteAlpha.300',
        },
        closeTrigger: {
            color: 'whiteAlpha.700',
            rounded: 'full',
            _hover: {
                bg: 'whiteAlpha.100',
                color: 'white',
            },
        },
    },
    variants: {
        placement: {
            bottom: {
                positioner: {
                    bottom: 'calc(env(safe-area-inset-bottom) + var(--action-bar-offset))',
                    justifyContent: 'center',
                },
            },
            'bottom-start': {
                positioner: {
                    bottom: 'calc(env(safe-area-inset-bottom) + var(--action-bar-offset))',
                    justifyContent: 'flex-start',
                    ps: 'var(--action-bar-offset)',
                },
            },
            'bottom-end': {
                positioner: {
                    bottom: 'calc(env(safe-area-inset-bottom) + var(--action-bar-offset))',
                    justifyContent: 'flex-end',
                    pe: 'var(--action-bar-offset)',
                },
            },
        },
    },
    defaultVariants: {
        placement: 'bottom',
    },
});
